const PATH = {
  HOME: '/',
  INFOPAY: '/infor-pay',
  TYPEPAY: '/type-pay',
  RESULTPAY: '/result-pay',
  QRPAY: '/qr-pay',
  OTHER: '/other',
  NO_MATCH: '*',
};

export default PATH;
